import { Popover, Text } from '@medly-components/core';
import { ChevronDownIcon } from '@medly-components/icons';
import { useContext, type FC } from 'react';
import { FlatDatePickerButton } from './DatePickerButton.styled';

export const DatePickerButton: FC = () => {
    const [isCalendarOpen] = useContext(Popover.Context);

    return (
        <FlatDatePickerButton isCalendarOpen={isCalendarOpen}>
            <Text>Date</Text>
            <ChevronDownIcon />
        </FlatDatePickerButton>
    );
};

DatePickerButton.displayName = 'DatePickerButton';
